import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent {
  showPassword = false;
  showConfirmPassword = false;
  password: string = '';
  confirmPassword: string = '';
  email: string = '';

  constructor(private authService: AuthService, private userService: UserService, private router: Router, private loaderService: LoadingService) {
    const navigation = this.router.getCurrentNavigation();
    const email = navigation?.extras.state?.['email'] || null;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      alert('Please enter a valid email address');
      return;
    }
    this.email = email;
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmShowPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  resetPassword() {
    if (this.password !== this.confirmPassword) {
      alert('Passwords do not match');
      return;
    }

    const user = { email: this.email, sub: this.password };
    this.loaderService.showLoading();
    this.authService.resetPassword(user).subscribe({
      next: (response: any) => {
        this.loaderService.hideLoading();
        this.userService.setTokenInfo(response.accessToken, response.refreshToken, response.userId, response.role);
        window.location.href = '/';
      },
      error: (error) => {
        this.loaderService.hideLoading();
      },
    });
  }
}
